// types/workPreference.ts
export interface WorkPreference {
  id?: number;
  memberId: number;
  departmentId: number;
  preferenceDate: string;
  preferenceType: number;
  memo?: string;
}

export interface AvailableMember {
  ID: number;
  staff_initial: string;
  LastName: string;
  FirstName: string;
  Department_ID: number;
  Department_Name: string;
  Department_Type: string;
  Preference_Type?: number | null;
  Memo?: string | null;
}

export const PREFERENCE_TYPES = {
  WANT_OFF: 0,
  MUST_WORK: 1,
  PREFER_WORK: 2
};

export const PREFERENCE_TYPE_LABELS = {
  [PREFERENCE_TYPES.WANT_OFF]: '休みたい',
  [PREFERENCE_TYPES.MUST_WORK]: '必ず働きたい',
  [PREFERENCE_TYPES.PREFER_WORK]: 'できれば働きたい'
};

export const PREFERENCE_TYPE_COLORS = {
  [PREFERENCE_TYPES.WANT_OFF]: '#f44336',
  [PREFERENCE_TYPES.MUST_WORK]: '#4caf50',
  [PREFERENCE_TYPES.PREFER_WORK]: '#2196f3'
};